export default {
  getTechnicalCondition: (axios, digitalCertificateId) =>
    axios.get(
      `/api/digitalCertificates/${digitalCertificateId}/technicalCondition`,
    ),
  saveTechnicalCondition: (axios, digitalCertificateId, data) =>
    axios.post(
      `/api/digitalCertificates/${digitalCertificateId}/technicalCondition`,
      data,
    ),
  saveTechnicalConditionImage: (
    axios,
    digitalCertificateId,
    technicalConditionGroupId,
    data,
  ) =>
    axios.post(
      `/api/digitalCertificates/${digitalCertificateId}/technicalCondition/${technicalConditionGroupId}/image`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    ),
  deleteTechnicalConditionImage: (
    axios,
    digitalCertificateId,
    technicalConditionGroupId,
    imageId,
  ) =>
    axios.delete(
      `/api/digitalCertificates/${digitalCertificateId}/technicalCondition/${technicalConditionGroupId}/image/${imageId}`,
    ),
}
